import * as VOXLib from 'voximplant-websdk';
import type { Call } from 'voximplant-websdk/Call/Call';

/** Установить слушатель события присоединения к конференции */
export function attachVOXConnectedEvent(voxCall: Call, setConnected: (result: boolean) => void) {
    voxCall.on(VOXLib.CallEvents.Connected, () => {
        setConnected(true);
    });
}
